export default "__VITE_ASSET__BYMi5Pmg__"